import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of, take } from 'rxjs';
import {
  Sc3FailedMessagesExportSetInitialState,
  Sc3FailedMessagesExportStart,
} from './sc3-failed-messages-export.actions';
import { Sc3FailedMessagesExportService } from './sc3-failed-messages-export.service';
import { catchError, map } from 'rxjs/operators';
import { NavigateUserService } from '../../../../../services/navigate-user.service';
import { NotificationService } from '../../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../../common/constants';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface Sc3FailedMessagesExportStateModel {
  loaded: boolean;
}

const initialState: Sc3FailedMessagesExportStateModel = {
  loaded: false,
};

@State({
  name: 'sc3FailedMessagesExport',
  defaults: initialState,
})
@Injectable()
export class Sc3FailedMessagesExportState {
  @Selector()
  static getState(state: Sc3FailedMessagesExportStateModel): Sc3FailedMessagesExportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: Sc3FailedMessagesExportStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private sc3FailedMessagesExportService: Sc3FailedMessagesExportService,
    private notificationService: NotificationService,
    private navigateUserService: NavigateUserService,
  ) {}

  @Action(Sc3FailedMessagesExportStart)
  startExportToFile(
    ctx: StateContext<Sc3FailedMessagesExportStateModel>,
    { payload: { dialogRef, ...params } }: Sc3FailedMessagesExportStart,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    // TODO: add type
    return this.sc3FailedMessagesExportService.startExportToFile(params).pipe(
      take(1),
      map(() => {
        this.notificationService.success('api.export.success.exportStart');
        ctx.patchState({ loaded: true });
        dialogRef.close();
        if (params.navigationNeeded) {
          this.navigateUserService.navigateUserToAbsolutePath('/dashboard/exports');
        }
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc3FailedMessagesExportSetInitialState)
  setInitialState(ctx: StateContext<Sc3FailedMessagesExportStateModel>): void {
    ctx.setState(initialState);
  }
}
